import Vue from 'vue'
import sha1 from 'sha1'

const login = async ({ email, senha }) => {
  try {
    const response = await Vue.prototype.$http.post('/auth', {
      email,
      senha: sha1(senha)
    })
    return response.data.token
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const resetPassword = async ({ token, senha }) => {
  try {
    const response = await Vue.prototype.$http.patch('/usuario/passwordReset', {
      token,
      senha: sha1(senha)
    })
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const updateUser = async (user) => {
  try {
    user.cpf = user.cpf.replace(/\D/g, '')
    const data = Object.assign(
      {},
      user,
      user.senha ? { senha: sha1(user.senha) } : {}
    )
    const response = await Vue.prototype.$http.patch('/usuario', data)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const getUser = async (cpf = '') => {
  try {
    const response = await Vue.prototype.$http.get(`/usuario/${cpf}`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const createUser = async (usuario) => {
  try {
    usuario.cpf = usuario.cpf.replace(/\D/g, '')
    const response = await Vue.prototype.$http.post(`/usuario`, usuario)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const getUserClientes = async (cpf = '') => {
  try {
    const response = await Vue.prototype.$http.get(`/usuario/${cpf}/clientes`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const getUsers = async () => {
  try {
    const response = await Vue.prototype.$http.get(`/usuarios`)
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const createPasswordReset = async ({ email }) => {
  try {
    const response = await Vue.prototype.$http.post('/usuario/passwordReset', {
      email
    })
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

const getMe = async () => {
  try {
    const response = await Vue.prototype.$http.get('/me?refreshToken=true')
    return response.data
  } catch (error) {
    if (error.response) throw new Error(error.response.data)
    throw error
  }
}

export {
  login,
  resetPassword,
  createPasswordReset,
  getMe,
  updateUser,
  getUser,
  createUser,
  getUserClientes,
  getUsers
}